import { Link } from 'react-router-dom';

const rankingLinks = [
  { to: '/ranking/popularity', label: '韩漫人气榜' },
  { to: '/ranking/rating', label: '韩漫评分榜' },
  { to: '/ranking/must-read', label: '韩漫必看榜' },
];

const categoryLinks = ['都市恋爱', '奇幻战斗', '古风武侠', '热血搞笑', '灵异悬疑', '美食日常'];

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-foreground-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-background-50">韩漫精选榜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
              一站看好看的韩国漫画。聚合人气榜、评分榜与必看榜，实时更新高分韩漫清单，帮你快速锁定当下最值得追的作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="mailto:hello@hanmanjingxuan.cn"
                className="flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-line text-sm" />
                联系我们
              </a>
              <Link
                to="/faq"
                className="flex items-center gap-2 rounded-full border border-background-200/30 px-4 py-2 text-sm font-medium text-foreground-100 transition-colors hover:border-primary-400 hover:text-primary-300"
              >
                <i className="ri-question-line text-sm" />
                常见问题
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-background-50">热门榜单</h3>
            <ul className="mt-4 space-y-3">
              {rankingLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-300 transition-colors hover:text-primary-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wider text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-3">
              {categoryLinks.map((c) => (
                <li key={c}>
                  <Link to={`/ranking/popularity?genre=${encodeURIComponent(c)}`} className="text-sm text-foreground-300 transition-colors hover:text-primary-300">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200/20 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">© {new Date().getFullYear()} 韩漫精选榜 · 收录评分与榜单数据仅供阅读参考</p>
          <div className="flex items-center gap-4">
            <a href="mailto:hello@hanmanjingxuan.cn" className="text-xs text-foreground-400 transition-colors hover:text-primary-300">hello@hanmanjingxuan.cn</a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 transition-colors hover:text-primary-300">站点地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}